<template>
	<div>

		<div class="bg-white border-bottom">
			<div class="header mb-0">
				<div class="container-fluid">
					<div class="header-body py-0 mt-4 border-0">
						<div class="row align-items-end">
							<div class="col">
								<h6 class="header-pretitle">Overview</h6>
								<h1 class="header-title">Trips</h1>
							</div>
						</div>
						<!-- / .row -->
					</div>
					<!-- / .header-body -->
				</div>
			</div>
			<div class="container-fluid">
				<div class="row pt-3 pb-1">
					<div class="col justify-self-center align-self-center flex-column">
						<ul class="nav nav-pills">
							<li class="nav-item">
								<router-link
									:to="{
										name: 'ActiveTrips',
									}"
									class="nav-link"
									active-class="active"
									>Active Trips</router-link
									>
							</li>
							<li class="nav-item">
								<router-link
									:to="{
										name: 'UpcomingTrips',
									}"
									class="nav-link"
									active-class="active"
									>Upcoming Trips</router-link
									>
							</li>
							<li class="nav-item">
								<router-link
									:to="{
										name: 'CompletedTrips',
									}"
									class="nav-link"
									active-class="active"
									>Completed Trips</router-link
									>
							</li>
							<li class="nav-item">
								<router-link
									:to="{name: 'BusCaptains'}"
									class="nav-link"
									active-class="active">
									Bus Captains
								</router-link>

							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div>
			<div class="container-fluid">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: {},
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
$primary: #01e069 !default;
$black: #060606 !default;

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: transparent;
  box-shadow: 0 3px 0 0px $primary;
  color: $black;
  font-weight: 800;
}

.nav-pills .nav-link,
.nav-pills .show > .nav-link {
  border-radius: 0;
}
</style>
